export const isPromise = <T>(value: T | Promise<T>): value is Promise<T> => {
    return typeof value === "object" && "then" in value;
};

export const ensurePromise = <T>(value: T | Promise<T>): Promise<T> => {
    return isPromise(value) ? value : Promise.resolve(value);
};